var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "signinForm", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "12" } }, [
            _c(
              "div",
              { staticClass: "sign" },
              [
                _c("div", { staticClass: "logo" }),
                _vm._v(" "),
                _vm.show && _vm.showLoginForm
                  ? _c(
                      "b-form",
                      { on: { submit: _vm.onSubmit, reset: _vm.onReset } },
                      [
                        _c("h3", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(_vm.$t("signin.head"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "welform" }, [
                          _vm.resetPasswordSent
                            ? _c("div", [
                                _c("hr"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "successAlert" },
                                  [
                                    _c("svg-image", {
                                      attrs: { image: "iconEnvelope" },
                                    }),
                                    _vm._v(" "),
                                    _c("h6", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signin.alert.sent.label")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("signin.alert.sent.desc"))
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resetSuccess
                            ? _c("div", [
                                _c("hr"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "successAlert" },
                                  [
                                    _c("svg-image", {
                                      attrs: { image: "iconKey" },
                                    }),
                                    _vm._v(" "),
                                    _c("h6", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signin.alert.reset.label")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signin.alert.reset.desc")
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.success
                            ? _c("div", [
                                _c("hr"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "successAlert" },
                                  [
                                    _c("svg-image", {
                                      attrs: { image: "iconCheck" },
                                    }),
                                    _vm._v(" "),
                                    _c("h6", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signin.alert.complete.label")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signin.alert.complete.desc")
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("hr"),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        !_vm.resetPasswordSent
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "email-group",
                                      label: _vm.$t("signin.form.email"),
                                      "label-for": "email",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "email",
                                        type: "email",
                                        required: "",
                                        state: _vm.validation,
                                      },
                                      model: {
                                        value: _vm.form.email,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "email", $$v)
                                        },
                                        expression: "form.email",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-invalid-feedback",
                                      { attrs: { state: _vm.validation } },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t("signin.form.emailmsg")
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.resetPasswordRequest
                                  ? _c(
                                      "b-form-group",
                                      {
                                        staticClass: "password",
                                        attrs: {
                                          id: "password-group",
                                          label: _vm.$t("signin.form.pwd"),
                                          "label-for": "password",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "password",
                                            type: "password",
                                            required: "",
                                            state: _vm.validation,
                                          },
                                          model: {
                                            value: _vm.form.password,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "password",
                                                $$v
                                              )
                                            },
                                            expression: "form.password",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-invalid-feedback",
                                          { attrs: { state: _vm.validation } },
                                          [
                                            _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.resetPassword.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "signin.form.pwdmsg"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.resetPasswordRequest &&
                                _vm.validation == undefined
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "resetBtn",
                                        attrs: { type: "reset" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.forgotPassword.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("signin.form.resetbtn"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("alert", { attrs: { status: _vm.status } }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "clearfix",
                                    staticStyle: { "margin-top": "1em" },
                                  },
                                  [
                                    _vm.resetPasswordRequest
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              squared: "",
                                              block: "",
                                              variant: "outline-primary",
                                              size: "lg",
                                              disabled: _vm.loading,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.resetPassword.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.loading
                                              ? _c("b-spinner", {
                                                  attrs: {
                                                    small: "",
                                                    type: "grow",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("signin.form.pwdmsg")
                                                )
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.resetPasswordRequest
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              squared: "",
                                              block: "",
                                              variant: "outline-primary",
                                              type: "submit",
                                              size: "lg",
                                              disabled: _vm.loading,
                                            },
                                          },
                                          [
                                            _vm.loading
                                              ? _c("b-spinner", {
                                                  attrs: {
                                                    small: "",
                                                    type: "grow",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("signin.btn"))
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("signin.agree")
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cta-register text-center",
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "textlink",
                                            attrs: { href: "/signin/admin" },
                                          },
                                          [_vm._v("Admin Console")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.show && _vm.showResetForm
                  ? _c(
                      "b-form",
                      {
                        on: { submit: _vm.onReestPassword, reset: _vm.onReset },
                      },
                      [
                        _c("h3", { staticClass: "text-center mb-4" }, [
                          _vm._v(_vm._s(_vm.$t("signin.reset.head"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "password-group",
                              "label-for": "password",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  class: {
                                    valid: _vm.passwordValidation.valid,
                                  },
                                  attrs: {
                                    id: "password",
                                    type: _vm.passwordVisible
                                      ? "text"
                                      : "password",
                                    required: "",
                                    placeholder: _vm.$t("signin.reset.place1"),
                                    state: _vm.passwordChecker,
                                  },
                                  model: {
                                    value: _vm.form.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "password", $$v)
                                    },
                                    expression: "form.password",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "hideandseek",
                                        attrs: {
                                          variant: "info",
                                          "arial-label": _vm.passwordVisible
                                            ? "Hide password"
                                            : "Show password",
                                        },
                                        on: {
                                          click: _vm.togglePasswordVisibility,
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: _vm.passwordVisible
                                              ? "eye-slash-fill"
                                              : "eye-fill",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "mt-2",
                              attrs: {
                                id: "checkPassword",
                                type: "password",
                                required: "",
                                placeholder: _vm.$t("signin.reset.place2"),
                                state: _vm.passwordChecker,
                              },
                              model: {
                                value: _vm.form.confirmPassword,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "confirmPassword", $$v)
                                },
                                expression: "form.confirmPassword",
                              },
                            }),
                            _vm._v(" "),
                            _c("alert", { attrs: { status: _vm.status } }),
                            _vm._v(" "),
                            _c(
                              "b-form-invalid-feedback",
                              { attrs: { state: _vm.passwordChecker } },
                              [
                                _c(
                                  "ul",
                                  [
                                    _vm._l(
                                      _vm.passwordValidation.errors,
                                      function (error) {
                                        return _c("li", [_vm._v(_vm._s(error))])
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm.notSamePasswords
                                      ? _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("signin.reset.errmsg5")
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-form-valid-feedback", {
                              attrs: { state: _vm.passwordChecker },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "clearfix mb-4" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  squared: "",
                                  block: "",
                                  variant: "outline-primary",
                                  type: "submit",
                                  size: "lg",
                                  disabled: _vm.loading,
                                },
                              },
                              [
                                _vm.loading
                                  ? _c("b-spinner", {
                                      attrs: { small: "", type: "grow" },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("signin.reset.btn"))
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("signin.agree")),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.show && _vm.showLoginForm
            ? _c(
                "div",
                { staticClass: "overlapButton" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        squared: "",
                        block: "",
                        variant: "primary",
                        to: "/signup",
                        size: "lg",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("signin.reg")))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/SigninView.vue